import React, { useState, useEffect, useContext, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { trackEvent, trackPageView } from "../../utils/tracking";
function SMSCodeForScheme() {
  useEffect(() => {
    //trackPageView('https://www.jmfinancialmf.com/SMS-Code-For-Scheme', 'jmf_sms-scheme-code');
    trackPageView(
      "https://www.jmfinancialmf.com/SMS-Code-For-Scheme",
      "jmf_sms-scheme-code"
    );

    trackEvent({
      category: "Static Page",
      action: "SMS Scheme Code Page Loaded",
      label: "jmf_sms-scheme-code",
      value: 1,
    });
  }, []);

  const { BaseURL } = useContext(URLstateContext);
  const [path, setPathnameURL] = useState("");
  useEffect(() => {
    var pathnameurl = window.location.pathname;
    const regEx = new RegExp("-", "g");
    const resultName = pathnameurl.replace(regEx, " ");
    setPathnameURL(resultName);
  });
  return (
    <>
      <section className="navs-and-dividends-section">
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                {/* <li><a href="/NavsAndIDCW"><i>NavsAndIDCW</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li> */}
                {window.location.pathname != "/NavsAndIDCW" ? (
                  <li>{path.replace("/", "")}</li>
                ) : (
                  ""
                )}
              </ul>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            <Col sm={12}>
              <div className="">
                <h2>SMS Code For Scheme</h2>
                <p className="p-gray-text text-center">
                  The Investor may send an SMS at (9028364444) by typing the SMS
                  code mentioned in Column D of the table{" "}
                  <a href={"CMS/pdf/SmsCodeforScheme.xls"} target="_blank">
                    (Click Here To View)
                  </a>{" "}
                  e.g. for getting NAV through SMS of JM Arbitrage Fund - (Regular) - IDCW Option, pl type JM J159 for Regular Plan and JM J433 for Direct Plan and send SMS to the above number.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default SMSCodeForScheme;
